import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import Slide from "@material-ui/core/Slide";
import { StyledButton } from "src/components/CustomButtons/TgButton";
import { deleteLogoFile } from "../services/firestore";

const DeleteLogo = ({ conjunto, setFiles, ind, img }) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedFile, setSelectedFile] = useState({ index: null, url: null });

  const handleFileDelete = async () => {
    const { index, image } = selectedFile;
    const fileDelete = await deleteLogoFile(image, conjunto);
    if (fileDelete === 1) {
      setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
      setOpenConfirm(false);
    }
  };

  return (
    <>
      <IconButton
        onClick={() => {
          setSelectedFile({ ind, img });
          setOpenConfirm(true);
        }}
      >
        <Delete />
      </IconButton>
      <Dialog
        open={openConfirm}
        TransitionComponent={Slide}
        keepMounted
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          ¿Estás seguro de eliminar?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Si eliminas, el archivo no se visualizará en la aplicación
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={() => setOpenConfirm(false)} color="primary">
            Cancelar
          </StyledButton>
          <StyledButton onClick={() => handleFileDelete()} color="primary">
            Eliminar
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteLogo;
